module.exports = __webpack_public_path__ + "static/media/logo-dark.f2d67e8b.svg";